export function dateFormat (date, fmt) {
  let exp = date
  if (!exp && typeof (exp) !== 'undefined' && exp !== 0) {
    fmt = null
  } else {
    date = new Date(date)
    if (typeof (fmt) === 'undefined') {
      fmt = 'yyyy-MM-dd HH:mm:ss'
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
      }
    }
  }
  return fmt
};


// WEBPACK FOOTER //
// ./src/util/date.js